import {cn} from "@/lib/utils";
import {ReactNode} from "react";

export default function Container({large, alt, className, children}: {
    large?: boolean,
    alt?: string,
    className?: string,
    children: ReactNode
}) {
    return (
        <div
            className={cn(
                "container px-8 mx-auto xl:px-5",
                large ? " max-w-(--breakpoint-xl)" : " max-w-(--breakpoint-lg)",
                !alt && "py-5 lg:py-8",
                className
            )}>
            {children}
        </div>
    );
}
